import { useMutation } from "@tanstack/react-query";
import { apig } from "../config/query/clientgen";
import { MiningPoolCredentialsDto } from "../model/api";

export const useSetupMiningProxy = () => {
  return useMutation(async (data: MiningPoolCredentialsDto) => {
    return apig.miningProxy.setupMiningProxy(data);
  });
};
